
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aller-simple",
      function () {
        return require("private-next-pages/aller-simple/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aller-simple"])
      });
    }
  